/* eslint-disable global-require */
import angular from 'angular';

import ProfileImageUploadController from './upload.controller';
import './upload.styles.scss';

export default angular.module('autoboard.profileImageUpload', [])
  .directive('profileImageUpload', () => {
    'ngInject';

    return {
      controller: ProfileImageUploadController,
      restrict: 'E',
      transclude: true,
      scope: {
        userId: '<', // optional, if none is provided the current user id will be used
      },
      // @ts-ignore
      templateUrl: require('./upload.template.html'),
    };
  })
  .name;
